module.exports = __webpack_public_path__ + "static/buffalo-ae3d400749116675728853bba1124fe3.svg";